import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import React, { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import useService from "../../hooks/hook-service";
import classNames from "classnames";
import { BANK_CATALOG_TYPE, BANK_CONFIG_BY_TRANSFER_TYPE, NON_BANK_TRANSFER_TYPES } from "../../constants";

const WayToPay = ({ catalogPaymentType, addButton, requiredAmount = true }) => {
  const [paymentTypes, setPaymentTypes] = useState(catalogPaymentType ?? []);
  const [allBanks, setAllBanks] = useState([]);
  const [banks, setBanks] = useState([]);
  const {
    register,
    watch,
    control,
    setValue,
    formState: { errors },
  } = useFormContext();
  const { post } = useService();
  const transferType = watch("transferType");

  const isBankTransfer = transferType && !NON_BANK_TRANSFER_TYPES.includes(transferType);

  useEffect(() => {
    post("catalog/list", { catalogType: "1004" }, ({ catalogs }) =>
      setPaymentTypes(catalogs)
    );
    post("catalog/list", { catalogType: String(BANK_CATALOG_TYPE) }, ({ catalogs }) =>
      setAllBanks(catalogs)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setValue("referenceNumber", "");
    if (!isBankTransfer) {
      setValue("bank", null);
      setBanks([]);
      return;
    }
    const config = BANK_CONFIG_BY_TRANSFER_TYPE[transferType];
    setBanks(config ? allBanks.filter(b => (b.configuration & config) === config) : allBanks);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transferType, allBanks]);

  return (
    <>
      <div className="col-12 md:col-2">
        <label htmlFor="input">Tipo de Transferencia</label>
      </div>
      <div className="col-12 md:col-4">
        <Controller
          control={control}
          defaultValue={18}
          name="transferType"
          rules={{ required: true }}
          render={({ field }) => (
            <Dropdown
              id="transferType"
              optionLabel="name"
              optionValue="id"
              className={classNames({
                "p-invalid": !!errors.transferType,
              })}
              placeholder="Seleccione un tipo"
              {...field}
              options={paymentTypes}
            />
          )}
        />
      </div>
      {requiredAmount && (
        <>
          <div className="col-12 md:col-2">
            <label htmlFor="input">Monto</label>
          </div>
          <div className="col-12 md:col-4">
            <InputText type="number" {...register("amount")} />
            {addButton}
          </div>
        </>
      )}
      {isBankTransfer && (
        <>
          <div className="col-12 md:col-2">
            <label htmlFor="input">Banco</label>
          </div>
          <div className="col-12 md:col-4">
            <Controller
              control={control}
              name="bank"
              rules={{ required: isBankTransfer }}
              render={({ field }) => (
                <Dropdown
                  id="bank"
                  optionLabel="name"
                  dataKey="id"
                  className={classNames({
                    "p-invalid": !!errors.bank,
                  })}
                  placeholder="Seleccione un banco"
                  {...field}
                  options={banks}
                />
              )}
            />
          </div>
          <div className="col-12 md:col-2">
            <label htmlFor="input">Número de Referencia</label>
          </div>
          <div className="col-12 md:col-4">
            <InputText
              className="reference-number"
              type="text"
              {...register("referenceNumber")}
            />
          </div>
        </>
      )}
    </>
  );
};

export default WayToPay;
